import { createElementBlock as n, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(a, e) {
  return o(), n("svg", t, e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.023 12.976a1.8 1.8 0 0 0-.603-.397L3.284 9.718a.45.45 0 0 1 .021-.843l17.098-5.85a.446.446 0 0 1 .572.572l-5.85 17.098a.45.45 0 0 1-.843.021l-2.861-7.138a1.8 1.8 0 0 0-.398-.601Zm0 0 9.845-9.843"
    }, null, -1)
  ]));
}
const s = { render: l };
export {
  s as default,
  l as render
};
